import React from "react";
import { PageHeader } from "../components/AppLayout";
import { Clock } from "lucide-react";

export default function ComingSoon({ title }) {
  return (
    <div className="ri-fade-in">
      <PageHeader overline="Modulo" title={title} />
      <div className="rounded-xl bg-white border border-slate-200 p-12 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-100 text-slate-600 text-sm font-medium mb-4">
          <Clock size={16} /> In arrivo
        </div>
        <p className="text-slate-500 max-w-lg mx-auto text-sm">
          Il modulo <b>{title}</b> è in fase di rilascio. Lo schema dati, le relazioni e la struttura
          del workflow sono già predisposti nel backend per l'attivazione senza ridisegno.
        </p>
      </div>
    </div>
  );
}
